"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _memoize = _interopRequireDefault(require("./util/memoize"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function createNormalizeOnBlurField(Field) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inherits2.default)(NormalizeOnBlurField, _React$Component);

    function NormalizeOnBlurField() {
      var _getPrototypeOf2;

      var _this;

      (0, _classCallCheck2.default)(this, NormalizeOnBlurField);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(NormalizeOnBlurField)).call.apply(_getPrototypeOf2, [this].concat(args)));
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_input", null);
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "BlurHandler", (0, _memoize.default)(function (Comp) {
        return function (_ref) {
          var _ref$input = _ref.input,
              _onBlur = _ref$input.onBlur,
              input = (0, _objectWithoutProperties2.default)(_ref$input, ["onBlur"]),
              props = (0, _objectWithoutProperties2.default)(_ref, ["input"]);

          var enterListener = function enterListener(event) {
            if (event.keyCode === 13) {
              var normalizeOnBlur = _this.props.normalizeOnBlur;
              var value = event && event.target && event.target.hasOwnProperty('value') ? event.target.value : event;
              var newValue = normalizeOnBlur ? normalizeOnBlur(value) : value;
              input.onChange(newValue);
            }
          };

          return React.createElement(Comp, (0, _extends2.default)({}, props, {
            input: (0, _objectSpread2.default)({}, input, {
              onKeyDown: function onKeyDown(event) {
                enterListener(event);
                if (input.onKeyDown) input.onKeyDown(event);
              },
              onBlur: function onBlur(event) {
                var normalizeOnBlur = _this.props.normalizeOnBlur;
                var value = event && event.target && event.target.hasOwnProperty('value') ? event.target.value : event;
                var newValue = normalizeOnBlur ? normalizeOnBlur(value) : value;

                _onBlur(newValue);
              }
            })
          }));
        };
      }));
      return _this;
    }

    (0, _createClass2.default)(NormalizeOnBlurField, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            component = _this$props.component,
            normalizeOnBlur = _this$props.normalizeOnBlur,
            props = (0, _objectWithoutProperties2.default)(_this$props, ["component", "normalizeOnBlur"]);

        if (normalizeOnBlur) {
          return React.createElement(Field, (0, _extends2.default)({}, props, {
            component: this.BlurHandler(component)
          }));
        }

        return React.createElement(Field, (0, _extends2.default)({}, props, {
          component: component
        }));
      }
    }]);
    return NormalizeOnBlurField;
  }(React.Component), (0, _defineProperty2.default)(_class, "propTypes", {
    normalizeOnBlur: _propTypes.default.func
  }), _temp;
}

module.exports = createNormalizeOnBlurField;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form-normalize-on-blur/createNormalizeOnBlurField.js
// module id = 6362
// module chunks = 6